import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import brochure1 from "../../assets/nw/Nava-Karnataka-brochure-1.pdf-1536x1086.png"; // Convert the PDF to image or use jpg version
import brochure2a from "../../assets/nw/Untitled-design-2.png";
import brochure2b from "../../assets/nw/Untitled-design-3.png";
import HeaderSec from "../common/HeaderSec";
import Footer from "../common/Footer";

const EBrochureSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! We will contact you soon.");
    setFormData({ name: "", phone: "", email: "" });
  };

  const renderForm = () => (
    <Box
      sx={{
        maxWidth: 600,
        mx: "auto",
        mt: 4,
        mb: 6,
        p: 4,
        backgroundColor: "#f9f9f9",
        borderRadius: 3,
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          textAlign: "center",
          mb: 3,
          color: "#025253",
        }}
      >
        BOOK A FREE SITE VISIT
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              name="name"
              label="Full Name *"
              value={formData.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              name="phone"
              label="Contact Number *"
              inputProps={{ maxLength: 12 }}
              helperText={`${formData.phone.length} of 12 max characters.`}
              value={formData.phone}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="email"
              label="Email"
              type="email"
              value={formData.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "#025253",
                px: 5,
                py: 1.5,
                fontWeight: 600,
                borderRadius: "25px",
                "&:hover": { backgroundColor: "#00796b" },
              }}
            >
              Book Now
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );

  return (
    <Box>
      <HeaderSec />
      <Box sx={{ backgroundColor: "#fff", py: 8 }}>
        <Container maxWidth="lg">
          {/* -------- KALPAVRUKSHA GREEN -------- */}
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "28px", md: "36px" },
                color: "#025253",
                mb: 1,
              }}
            >
              KALPAVRUKSHA GREEN
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "16px", md: "18px" },
                color: "#388e3c",
                fontWeight: 600,
                mb: 4,
              }}
            >
              (Bookings Open)
            </Typography>

            {/* Brochure Image */}
            <Box
              component="img"
              src={brochure1}
              alt="Kalpavruksha Green Brochure"
              sx={{
                width: "100%",
                maxWidth: "100%",
                borderRadius: 2,
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                mb: 4,
              }}
            />

            {/* Download Button */}
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#025253",
                px: 5,
                py: 1.5,
                fontWeight: 600,
                borderRadius: "25px",
                "&:hover": { backgroundColor: "#00796b" },
              }}
            >
              Download Kalpavruksha Green - E Brochure
            </Button>

            {/* Contact Form */}
            {renderForm()}

            {/* Google Map */}
            <Box
              sx={{
                width: "100%",
                height: "450px",
                borderRadius: 2,
                overflow: "hidden",
                mb: 8,
                mt: 4,
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d13007.790323236082!2d77.740611!3d13.217139!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDEzJzAxLjciTiA3N8KwNDQnMjYuMiJF!5e1!3m2!1sen!2sus!4v1761723970673!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Kalpavruksha Green Location"
              ></iframe>
            </Box>
          </Box>

          {/* -------- VAIBHAVA GREENS -------- */}
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "28px", md: "36px" },
                color: "#025253",
                mb: 1,
              }}
            >
              VAIBHAVA GREENS
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "16px", md: "18px" },
                color: "#c62828",
                fontWeight: 600,
                mb: 4,
              }}
            >
              (Bookings Closed)
            </Typography>

            {/* Brochure Images */}
            <Grid container spacing={3} justifyContent="center" mb={4}>
              {[brochure2a, brochure2b].map((img, idx) => (
                <Grid item xs={12} md={6} key={idx}>
                  <Box
                    component="img"
                    src={img}
                    alt={`Vaibhava Greens ${idx + 1}`}
                    sx={{
                      width: "100%",
                      borderRadius: 2,
                      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                    }}
                  />
                </Grid>
              ))}
            </Grid>

            {/* Download Button */}
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#025253",
                px: 5,
                py: 1.5,
                fontWeight: 600,
                borderRadius: "25px",
                "&:hover": { backgroundColor: "#00796b" },
              }}
            >
              Download Vaibhava Greens - E Brochure
            </Button>

            {/* Contact Form */}
            {renderForm()}
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default EBrochureSection;
